import { useDebugValue, useEffect, useState } from 'react';
import scriptJS from 'scriptjs';
import PropTypes from 'prop-types';

import ExtendableError from './ExtendableError';
import config from '../igglo_config';
import { genAsyncSingleton } from './sharedUtils';

export const getStripe = genAsyncSingleton(() => new Promise(resolve =>
  scriptJS('https://js.stripe.com/v3/', () => resolve(new window.Stripe(config.stripe_key)))
));

export function useStripe() {
  const [stripe, setStripe] = useState(getStripe.getCurrentValue());

  useEffect(() => {
    if (stripe === null) {
      let canceled = false;

      getStripe().then(it => { if (!canceled) { setStripe(it) } });

      return () => { canceled = true };
    }

    return undefined;
  }, [stripe]);

  useDebugValue((stripe === null) ? 'Not loaded' : 'Loaded');

  return stripe;
}

export const stripeShape = PropTypes.shape({
  elements: PropTypes.func,
  confirmPaymentIntent: PropTypes.func,
  confirmSetupIntent: PropTypes.func,
  createPaymentMethod: PropTypes.func,
  createSource: PropTypes.func,
  createToken: PropTypes.func,
  handleCardAction: PropTypes.func,
  handleCardPayment: PropTypes.func,
  handleCardSetup: PropTypes.func,
  paymentRequest: PropTypes.func,
  redirectToCheckout: PropTypes.func,
  retrievePaymentMethod: PropTypes.func,
  retrieveSetupIntent: PropTypes.func,
  retrieveSource: PropTypes.func
});

export const elementsShape = PropTypes.shape({
  getElement: PropTypes.func.isRequired
});


export class SetupIntentNotCompletedError extends ExtendableError {
  constructor(setupIntent) {
    super(
      `Setup intent (${setupIntent.id}) was not completed. It's status is (${setupIntent.status})`
    );

    this.setupIntent = setupIntent;
  }
}

export class PaymentIntentNotCompletedError extends ExtendableError {
  constructor(paymentIntent) {
    super(
      `Payment intent (${paymentIntent.id}) was not completed. It's status is (${paymentIntent.status})`
    );

    this.paymentIntent = paymentIntent;
  }
}

export class StripeError extends ExtendableError {
  constructor(error) {
    super(error.message);

    Object.keys(error)
      .filter(it => (it !== 'message'))
      .forEach(key => { this[key] = error[key] });
  }
}
